import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import Header from "../../global/Header";
import Footer from "../../global/Footer";
import { ReactComponent as GroupLogo } from "../../data/svg/6334.svg";
import { ReactComponent as AnalyticsLogo } from "../../data/svg/6A.svg";
import { ReactComponent as AcademyLogo } from "../../data/svg/6334Academy.svg";
import Heading from "../../components/Heading";
import Essay from "../../components/Essay";
import ButtonBar from "../../components/ButtonBar";
import Section from "../../components/Section";
import Services from "../../components/Services";
import { customColour } from "../../data/colour";
import {
  isTabWidth,
  servicesIntroHeading,
  servicesIntroEssay,
  servicesHeaderButtons,
  servicesPicture,
  servicesData,
  dark,
  servicesServicesHeading,
  servicesServicesEssay,
  menuItems,
} from "../../data/database";

const linkLogo = [
  {
    label: "Academy",
    LinkLogoSvg: AcademyLogo,
    link: "/academy/home",
  },
  {
    label: "Analytics",
    LinkLogoSvg: AnalyticsLogo,
    link: "/analytics/home",
  },
];

const GroupServices = () => {
  const isTab = useMediaQuery(isTabWidth);

  return (
    <>
      {/* HERO SECTION */}
      <Box
        sx={{
          position: "relative",
          height: `${isTab ? "40vh" : "65vh"}`,
          overflow: "hidden",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundImage: `${servicesPicture}`,
        }}
      >
        <Box
          sx={{
            width: "80%",
            position: "absolute",
            top: `${isTab ? "30%" : "40%"}`,
            left: "50%",
            color: customColour.white,
            transform: "translate(-50%, 0)",
          }}
        >
          <Heading
            heading={servicesIntroHeading}
            fontSize={isTab ? "1.25rem" : "3rem"}
            fontweight={isTab ? "700" : "200"}
          />
          <Essay
            paragraphs={servicesIntroEssay}
            textAlign={isTab ? "center" : "center"}
            fontSize={isTab ? "0.9rem" : "1rem"}
            marginTop={isTab ? "0.25rem" : "1rem"}
          />
          <Box sx={{ width: `${isTab ? "100%" : "50%"}`, margin: "auto" }}>
            <ButtonBar
              buttons={servicesHeaderButtons}
              fontSize={isTab ? "0.9rem" : "1rem"}
              gap={isTab ? "0.75rem" : "2rem"}
              background="linear-gradient(
              to right bottom,
              rgba(0, 0, 0, 0.9),
              rgba(0, 0, 0, 0.7)
              )"
            />
          </Box>
        </Box>
      </Box>

      {/* SERVICES */}
      <Section
        image={dark}
        color={customColour.white}
        backgroundColor={customColour.darkBackground}
        width={isTab ? "90%" : "60%"}
        padding={isTab ? "2.5rem" : "5rem"}
      >
        <Heading
          heading={servicesServicesHeading}
          fontSize={isTab ? "1.25rem" : "3rem"}
          fontweight={isTab ? "400" : "200"}
        />
        <Essay
          paragraphs={servicesServicesEssay}
          textAlign={isTab ? "left" : "justify"}
          fontSize={isTab ? "0.9rem" : "1rem"}
        />
        <Services
          services={servicesData}
          fontSize={isTab ? "0.9rem" : "1rem"}
        />
      </Section>
    </>
  );
};

export default GroupServices;
